import { useState } from "react";
import { Search, Loader2, Phone, SearchX } from "lucide-react";
import { toast } from "sonner";
import { AppHeader } from "../components/AppHeader";
import { HotelSelect } from "../components/HotelSelect";
import { ResolveDialog } from "../components/ResolveDialog";
import { FeedbackCard } from "../components/FeedbackCard";
import { Input } from "../components/ui/input";
import { api, errMsg } from "../lib/api";

export default function GuestSearch() {
  const [mobile, setMobile] = useState("");
  const [hotel, setHotel] = useState("All");
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const [resolving, setResolving] = useState(null);

  const search = async (e) => {
    e?.preventDefault();
    if (mobile.replace(/\D/g, "").length < 4) return toast.error("Enter at least 4 digits of the mobile number");
    setBusy(true);
    try {
      const r = await api.get("/feedback/by-mobile", { params: { mobile, hotel } });
      setItems(r.data);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="relative z-10 min-h-screen">
      <AppHeader />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="rise mb-8">
          <div className="eyebrow">Guest lookup</div>
          <h1 className="mt-2 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-emerald-950">Search by mobile</h1>
          <p className="mt-3 text-slate-600 max-w-xl">Find a guest's past feedback across all Tamanna properties using their mobile number.</p>
        </div>
        <form onSubmit={search} className="glass rounded-3xl p-4 flex flex-wrap items-center gap-3 rise d1" data-testid="guest-search-form">
          <div className="relative flex-1 min-w-[220px]">
            <Phone className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input data-testid="guest-search-mobile-input" inputMode="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Mobile number, e.g. 98765 43210" className="h-12 pl-11 rounded-full bg-white text-base" />
          </div>
          <HotelSelect value={hotel} onChange={setHotel} allowAll testId="guest-search-hotel-filter" />
          <button data-testid="guest-search-submit-button" disabled={busy} className="h-12 px-6 rounded-full bg-emerald-900 text-amber-50 font-semibold hover:bg-emerald-800 flex items-center gap-2 transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />} Search
          </button>
        </form>
        {items && <div className="mt-6 mb-4 text-sm font-semibold text-emerald-900" data-testid="guest-search-count">{items.length} feedback found</div>}
        {items && items.length === 0 && (
          <div className="glass rounded-3xl p-12 text-center" data-testid="guest-search-empty">
            <SearchX className="mx-auto h-10 w-10 text-slate-400" />
            <div className="mt-3 font-display text-xl font-extrabold text-emerald-950">No feedback for this number</div>
          </div>
        )}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(items || []).map((i) => <FeedbackCard key={i.id} i={i} onResolve={setResolving} prefix="search" />)}
        </div>
      </main>
      <ResolveDialog item={resolving} onClose={() => setResolving(null)} onDone={search} />
    </div>
  );
}
